module.exports = __webpack_public_path__ + "public/images/header-slide-1.ca9c32ab30777f76b4e4b55840f2ce31.jpeg";